export default __webpack_public_path__ + "static/Entenda0041-11dfdb9d1bec1e311f5634375f2f3cf5.jpg";